var _defs, _circle, _path, _path2, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSaveWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:none;stroke:#FFF;stroke-width:3px;}.cls-1{stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-miterlimit:10;}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.46323,
    cy: 30.46323,
    r: 6.92886
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M42,3a3.00342,3.00342,0,0,1,3,3V42a3.00342,3.00342,0,0,1-3,3H6a3.00342,3.00342,0,0,1-3-3V6A3.00342,3.00342,0,0,1,6,3H42m0-3H6A6.01765,6.01765,0,0,0,0,6V42a6.01765,6.01765,0,0,0,6,6H42a6.01765,6.01765,0,0,0,6-6V6a6.01765,6.01765,0,0,0-6-6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    className: "cls-2",
    d: "M36.5,0V10.21118a6.01764,6.01764,0,0,1-6,6h-13a6.01764,6.01764,0,0,1-6-6V0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18.5,
    cy: 8.5,
    r: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaveWhite);
export default __webpack_public_path__ + "static/media/icon-save-white.c41f235d41f7dfd12d242f17cbaebcfe.svg";
export { ForwardRef as ReactComponent };